import { Component, OnDestroy } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-get-table-number',
    templateUrl: 'getTableNumber.html',
})
export class GetTableNumberPage implements OnDestroy {
    private _onDestroy = new Subject();
    tableNumber = '';

    constructor(public viewCtrl: ViewController,public customizer: CustomizerProvider,public translateService: TranslateService,) {}

    dismiss() {
        this.viewCtrl.dismiss(this.tableNumber);
    }

    inputNumber(n) {
        this.tableNumber = this.tableNumber.concat(n.toString())
    }
    
    cancelNumber() {
        this.tableNumber = '';
    }

    ngOnDestroy() {
        this._onDestroy.next();
    }
}



// WEBPACK FOOTER //
// ./src/pages/getTableNumber/getTableNumber.ts